import { useState, type ReactNode } from 'react';
import classes from './PersonOption.module.scss';

/** Данные карточки человека */
interface PersonOptionProps {
    name: string;
    phone?: string | null;
    photoUrl?: string | null;
    details?: string;
    blocked?: boolean;
    selected?: boolean;
    children?: ReactNode;
}

/** Показывает человека в результатах поиска и выбранной карточке */
export const PersonOption = (
    { name, phone, photoUrl, details, blocked, selected, children }: PersonOptionProps
) => {
    const [failedUrl, setFailedUrl] = useState<string | null>(null);
    const imageUrl = photoUrl?.trim();

    return <span className={classes.row}>
        <span
            className={classes.avatar}
            aria-hidden="true"
        >
            {imageUrl && failedUrl !== imageUrl
                ? <img
                    src={imageUrl}
                    alt=""
                    loading="lazy"
                    onError={() => setFailedUrl(imageUrl)}
                />
                : name.trim().charAt(0).toLocaleUpperCase('ru-RU') || '—'}
        </span>
        <span className={classes.info}>
            <span className={classes.name}>{name}</span>
            <span className={classes.phone}>{phone?.trim() || 'Телефон не указан'}</span>
            {details &&
                <span className={classes.details}>{details}</span>
            }
        </span>
        {children}
        {blocked &&
            <span className={classes.badge}>Заблокирован</span>
        }
        {selected &&
            <span
                className={classes.check}
                aria-hidden="true"
            >
                ✓
            </span>
        }
    </span>;
};
